// @flow
import React, { Component } from 'react';
import NameNewCampaign from './NameNewCampaign';
import ChooseAppGroupPage from './ChooseAppGroupPage';
import ChooseEntryEventPage from './ChooseEntryEventPage';

type Props = {};
type State = {
  page: string
};

class Wizard extends Component<Props, State> {
  state = { page: 'nameNewCampaign' };

  switchPage = (page: string) => {
    this.setState({ page });
  };

  render() {
    switch (this.state.page) {
      case 'nameNewCampaign':
        return <NameNewCampaign switchPage={this.switchPage} />;
      case 'chooseAppGroup':
        return <ChooseAppGroupPage switchPage={this.switchPage} />;
      case 'chooseEntryEvent':
        return <ChooseEntryEventPage />;
      default:
        return <NameNewCampaign switchPage={this.switchPage} />;
    }
  }
}

export default Wizard;



// WEBPACK FOOTER //
// ./src/Wizard.jsx